<template>
  <div class="col-12 connections">
    <div class="card federalResource">
      <div class="card-header">
        <h5 class="card-title mb-0">Федресурс</h5>
      </div>

      <div class="d-flex navs">
        <ul class="nav nav-tabs">
          <li>
            <a
              class="active grey-button"
              data-bs-toggle="tab"
              role="tab"
              aria-selected="true"
              >Все сообщения</a
            >
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="tab-content">
          <div class="tab-pane fade show active" role="tabpanel">
            <template v-if="federalResourceInfo?.result?.length">
              <div class="connections-list-container">
                <div
                  class="connections-list"
                  v-for="item in federalResourceInfo?.result"
                  :key="item.id"
                >
                  <div class="connections-list__header">
                    <h4>{{ item?.type_name }}</h4>
                  </div>
                  <div class="connections-list__body">
                    <p class="director">
                      <span>Дата: </span>{{ formatDate(item?.date_published) }}
                    </p>
                    <p class="director">
                      <span>Опубликовано: </span>{{ item?.publisher?.name }}
                    </p>
                    <p class="director">
                      <span>Участники: </span>
                      {{ formatParticipants(item?.participants) }}
                    </p>
                    <a class="btn-link" :href="item?.full_url" target="_blank"
                      >Прочитать полное сообщение</a
                    >
                  </div>
                </div>
              </div>
            </template>
            <template v-else><p class="text-center">Нет данных</p></template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref } from "vue";
import moment from "moment";

export default defineComponent({
  name: "FederalResource",
  props: {
    federalResourceInfo: Object,
  },
  setup(props) {
    const formatDate = (date) => {
      return moment(date).format("DD.MM.YYYY");
    };

    const formatParticipants = (arr) => {
      if (!Array.isArray(arr) || !arr.length) return "—";
      return arr
        .map((el) => el?.name)
        .filter(Boolean)
        .join(", ");
    };

    return {
      formatDate,
      formatParticipants,
    };
  },
});
</script>
